import Amplify from "aws-amplify";
import Providers from "components/Providers";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import awsconfig from "./aws-exports";
import reportWebVitals from "./reportWebVitals";
Amplify.configure(awsconfig);

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
